import { MenuRoot, ButtonIcon, MenuContent, MenuTrigger } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import {
  ChatHeaderMenuToggleChatReadStatusOption,
  ChatHeaderMenuMarkChatAndMessagesReadOption,
} from 'features/chat/components/ChatHeader/Menu/';
import { useChatContext } from 'features/chat/context/chat';

export const ChatHeaderMenu = () => {
  const { unreadMessagesCount } = useChatContext();

  return (
    <MenuRoot>
      <MenuTrigger asChild>
        <ButtonIcon
          aria-label="chat header menu"
          variant="ghost"
          size="xs"
          onClick={(evt) => {
            evt.stopPropagation();
          }}
        >
          <Icon name={iconNames.ellipsisHorizontal} />
        </ButtonIcon>
      </MenuTrigger>
      <MenuContent py="1px" overflow="hidden">
        {unreadMessagesCount ? (
          <ChatHeaderMenuMarkChatAndMessagesReadOption />
        ) : (
          <ChatHeaderMenuToggleChatReadStatusOption />
        )}
      </MenuContent>
    </MenuRoot>
  );
};
